import { render, staticRenderFns } from "./listTags.vue?vue&type=template&id=705fba42&scoped=true"
import script from "./listTags.vue?vue&type=script&lang=js"
export * from "./listTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fba42",
  null
  
)

export default component.exports